import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Menu, MenuItem, TextField, TableRow, TableHead, TableCell, TableBody, Table } from '@material-ui/core';
import { UserChip, CircleLoader } from '../../components';
import { deactivateUser, promoteUser, clearAchievements } from '../../actions/AdminActions';
import './AdminUserList.scss';

class AdminUserList extends Component {
  state = { userToBeDeactivated: null, userToBePromoted: null, filteredUsers: [], filter: '', userMenuOpen: [], achievementsToClear: '' };
  userOptionRefs = [];

  componentDidMount() {
    this.filterUsers();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.users !== nextProps.users) {
      this.filterUsers(null, nextProps.users);
    }

    if (nextProps.canClear && this.state.achievementsToClear !== '') {
      this.props.clearAchievements(this.state.achievementsToClear);
      this.setState({ achievementsToClear: '' });
    }
  }

  openMenu(index) {
    let menuStatuses = [];
    this.state.userMenuOpen.forEach((menu, i) => menuStatuses.push(index === i));
    this.setState({ userMenuOpen: menuStatuses });
  }

  closeMenu(index) {
    let menuStatuses = this.state.userMenuOpen;
    menuStatuses[index] = false;
    this.setState({ userMenuOpen: menuStatuses });
  }

  clearAchievements() {
    this.props.clearAchievements(this.state.achievementsToClear);
    this.setState({ achievementsToClear: '' });
  }

  // renderClearAchievements(_id) {
  //   const { role, clearAchievements } = this.props;
  //   if (role !== 'super_admin') return null;
  //   return (
  //     <ConfirmIcon
  //       tooltip="Clear Achievements"
  //       icon="star"
  //       onConfirm={() => clearAchievements(_id)}
  //     />
  //   );
  // }

  // renderPromote(_id, userRole) {
  //   const { promoteUser, role } = this.props;

  //   const isAlreadyAdmin = userRole === 'admin';
  //   const tooltip = isAlreadyAdmin ? 'Demote to Member' : 'Promote to Admin';

  //   if (role !== 'super_admin') return null;
  //   return (
  //     <ConfirmIcon
  //       disabled={userRole === 'super_admin'}
  //       disabledTooltip="Cannot demote super admins"
  //       tooltip={tooltip}
  //       icon="gavel"
  //       onConfirm={() => promoteUser(_id, !isAlreadyAdmin)}
  //     />
  //   );
  // }

  // renderDeactivate(_id, userRole, userDeactivated) {
  //   const { deactivateUser } = this.props;

  //   const tooltip = userDeactivated ? 'Reactivate' : 'Deactivate';

  //   return (
  //     <ConfirmIcon
  //       disabled={userRole === 'super_admin'}
  //       disabledTooltip="Cannot disable super admins"
  //       tooltip={tooltip}
  //       icon="block"
  //       onConfirm={() => deactivateUser(_id, !userDeactivated)}
  //     />
  //   );
  // }

  renderUsers() {
    const { filteredUsers } = this.state;
    const { promoteUser, deactivateUser, showClearAchievements } = this.props;
    return filteredUsers.map((user, i) => {
      const { displayName, deactivated, _id, email, role, shoutoutsReceived, shoutoutsSent } = user;
      const deactivatedClass = deactivated ? 'deactivated' : '';
      return (
        <TableRow key={_id} className={deactivatedClass + ' admin-user-row'}>
          <TableCell>
            <UserChip user={user} />
          </TableCell>
          <TableCell align="right">{email}</TableCell>
          <TableCell align="right">{shoutoutsReceived}</TableCell>
          <TableCell align="right">{shoutoutsSent}</TableCell>
          <TableCell align="right">{role || 'member'}</TableCell>
          <TableCell style={{ textAlign: 'right' }} align="right">
            <span className="menu-options-icon" onClick={() => this.openMenu(i)} ref={(ref) => this.userOptionRefs[i] = ref}>
              <Icon>more_vert</Icon>
            </span>
            <Menu onClose={() => this.closeMenu(i)} anchorEl={this.userOptionRefs[i]} open={this.state.userMenuOpen[i]}>
              <MenuItem className="clear-achievements-option"
                onClick={() => {
                  this.setState({ achievementsToClear: _id });
                  showClearAchievements(displayName);
                  this.closeMenu(i);
                }}
              >
                Clear Achievements
              </MenuItem>
              {role !== 'super_admin' &&
                <MenuItem onClick={() => { promoteUser(_id, role !== 'admin'); this.closeMenu(i); }} >
                  {role === 'member' ? 'Change to Workspace Admin' : 'Change to Member'}
                </MenuItem>
              }
              {role !== 'super_admin' &&
                <MenuItem onClick={() => { deactivateUser(_id, !deactivated); this.closeMenu(i); }}>
                  {deactivated ? 'Activate Member' : 'Deactivate Member'}
                </MenuItem>
              }
            </Menu>
          </TableCell>
        </TableRow>
      );
    });
  }

  filterUsers(e, users = this.props.users) {
    const filter = e ? e.target.value.toLowerCase() : this.state.filter;
    this.setState({ filter });

    if (filter === '') {
      this.setState({ filteredUsers: users });
      if (this.state.userMenuOpen.length !== this.props.users.length) {
        let open = [];
        this.props.users.forEach(() => open.push(false));
        this.setState({ userMenuOpen: open });
      }
      return;
    }
    const filteredUsers = users.filter(user => {
      return user.displayName.toLowerCase().indexOf(filter) > -1 ||
        user.email.toLowerCase().indexOf(filter) > -1;
    });
    this.setState({ filteredUsers });
  }

  render() {
    if (this.props.usersLoading) return <CircleLoader />;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', maxHeight: 600 }}>
        <div className="table-extra" style={{ padding: 8 }}>
          <TextField
            id="standard-full-width"
            label="Filter"
            className="text-field-input"
            autoFocus
            value={this.state.filter}
            onChange={this.filterUsers.bind(this)}
            placeholder="Filter by name or email"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true
            }}
          />
        </div>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Table className="admin-table admin-users-table" style={{ flex: 1 }}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="right">Email</TableCell>
                <TableCell align="right">Received</TableCell>
                <TableCell align="right">Sent</TableCell>
                <TableCell align="right">Role</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderUsers()}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ usersStore }) => {
  const { users, usersLoading, role } = usersStore;

  let activeUsers = users.filter((user) => !user.deactivated).sort((a, b) => {
    return a.displayName.localeCompare(b.displayName);
  });
  let inActiveUsers = users.filter((user) => user.deactivated).sort((a, b) => {
    return a.displayName.localeCompare(b.displayName);
  });
  return { users: [ ...activeUsers, ...inActiveUsers ], role, usersLoading };
};


export default connect(mapStateToProps, { deactivateUser, promoteUser, clearAchievements })(AdminUserList);


// WEBPACK FOOTER //
// ./src/screens/admin/AdminUserList.js